import * as React from "react";
import { Spin } from "antd";
import BaseComponent from "src/engine/ui/BaseComponent";
import UIInject, { IHandle } from "../UIInject";
import UIManifest from "src/engine/ui/UIManifest";
import IUIItem from "src/engine/interface/IUIItem";

interface IAntSpin {
    uiItem: IUIItem;
    value?: any;
    defaultValue?: any;
    style?: any;
}

interface IState { }

@UIManifest.declare("AntSpin", "Spin加载中", UIManifest.Type.AntD)
class AntSpin extends BaseComponent<IAntSpin, IState> {
    render() {
        const handles: IHandle[] = [];
        return <UIInject ui={Spin} {...this.props} handles={handles} />;
    }
}

export default AntSpin;
